module.exports = __webpack_public_path__ + "img/five.ff73a431.png";